var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"tile-debug",style:({height: _vm.props.size + 'px', width: _vm.props.size + 'px'})},[_c('div',[_vm._v(_vm._s(_vm.props.debug))])])}
var staticRenderFns = []

export { render, staticRenderFns }